<template>
  <lf-date-picker
    v-model="datesArray"
    class="date-filter h-6-5"
    :formatter="defaultDateFormatter"
    :date-placeholder="placeholder"
    :show-on-mount="toggleFromParent"
    hide-second-month
    @update:model-value="dateValue = $event"
  />
</template>

<script setup lang="ts">
import { useRouteQuery } from "@vueuse/router";
import { computed } from "vue";

import { defaultDateFormatter } from "@/helpers/constants/dateTime";

import LfDatePicker from "@/components/ui/inputs/LfDatePicker.vue";

const { queryKey = "task_due_date" } = defineProps<{
  queryKey?: string;
  placeholder: string;
  toggleFromParent?: boolean;
}>();
const dateValue = useRouteQuery(queryKey);

const datesArray = computed(() => {
  if (!dateValue.value?.length) {
    return [];
  }
  if (Array.isArray(dateValue.value)) {
    return dateValue.value.map((date) => String(date));
  }
  return [String(dateValue.value)];
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.date-filter :deep() {
  #litepie {
    & > button {
      @apply h-6-5 border-grey-hover bg-grey-hover py-0 pl-2 leading-[24px] text-headline;
    }
    & > div {
      @apply bottom-0 -left-15 scale-[0.8] transform;
    }
    & .top-3-4 {
      @apply top-1-5 right-1-5 scale-[0.75] transform;
    }
  }
}
</style>
